import axios from "axios";
import AuthenticationFailureHandler from "../utils/AuthenticationFailureHandler";
import { is401 } from "../errors/ErrorConstants";
import { ONBOARDING_BASE_URL } from "../utils/EmpUtil";

export default class AccessManagementClient {
  static baseUrl = ONBOARDING_BASE_URL;

  /**
   * Get users with EMP_Onboard role for a given dealer
   * @param {string} dealerCommonId
   * @returns {Promise<Array>}
   */
  static async getDealerRoles(dealerCommonId) {
    const url = `${this.baseUrl}/entitlements/kdm-users?dealerCommonId=${encodeURIComponent(dealerCommonId)}`;

    try {
      const response = await axios.get(url);
      return response.data ?? [];
    } catch (error) {
      if (is401(error)) AuthenticationFailureHandler.execute();
      throw error;
    }
  }

  /**
   * Get users for all access management roles, keyed by role name
   * @param {string} dealerCommonId
   * @returns {Promise<Object>}
   */
  static async getRoleUsers(dealerCommonId) {
    const url = `${this.baseUrl}/entitlements/role-users?dealerCommonId=${encodeURIComponent(dealerCommonId)}`;

    try {
      const response = await axios.get(url);
      return response.data ?? {};
    } catch (error) {
      if (is401(error)) AuthenticationFailureHandler.execute();
      throw error;
    }
  }
}
